import { request } from "@/service/request";
import { supplierMetaHost, supplierSettledHost } from "@/config/host";
import { SourceType } from "@/service/supplier-meta/types/SourceType";
import { HttpResponse } from "@/service/common/entity/HttpResponse";
import { AjaxResponse } from "@/service//supplier-meta/entity/AjaxResponse";
import { SupplierRespBo } from "@/service/supplier-meta/entity/SupplierRespBo";
import { BankCardBO } from "@/service/supplier-meta/entity/BankCardBO";
import { SupplierService } from "@/service/supplier-meta/entity/SupplierService";
import { FactoryTailDTO } from "@/service/supplier-meta/entity/FactoryTailDTO";
import { Enum } from "../entity/Enum";
import { localEnums } from "./localEnums";
import { get } from "lodash";
import { EditSupplierInfoBody } from "../entity/EditSupplierInfoBody";
import { SupplierInfoSubmitBO } from "../entity/SupplierInfoSubmitBO";
import { ImageUploadServerDTO } from "@/service/supplier-manage/entity/ImageUploadServerDTO";
import { Category } from "@/service/product/entity/Category";

import { NewCategory } from "@/service/product/entity/NewCategory";
import {
  getItem as getSessionStorageItem,
  setItem as setSessionStorageItem,
} from "@/service/common/storage/sessionStorage";
import { SupplierSettledResult } from "../entity/SupplierSettledResult";
import { ResNewProductCategoryDTO } from "../entity/ResNewProductCategoryDTO";
import { NewProductCategoryResponseDTO } from "../entity/NewProductCategoryResponseDTO";
export function getSupplier(
  sourceType: SourceType,
  supplierId: number
): Promise<AjaxResponse<SupplierRespBo>> {
  return request({
    url: supplierSettledHost + `/supplierSettled/supplier/${supplierId}`,
    method: "get",
    params: {
      sourceType,
    },
  });
}

/**
 * 获取所有分类（旧）
 */
export function getAllCategoryTree(): Promise<HttpResponse<Category[]>> {
  return request({
    url: `${supplierSettledHost}/applet/appletSupplierBase/getCategory`,
    method: "get",
  });
}

/**
 * 获取分类（新）
 * @param query
 * @returns
 */
export async function getAllNewCategoryTree(
  useCachae = false
): Promise<AjaxResponse<NewCategory[]>> {
  const cacheKey = "newCategories";
  if (useCachae) {
    const data = getSessionStorageItem(cacheKey);
    if (Array.isArray(data)) {
      return Promise.resolve({
        isSuccess: true,
        result: data,
      });
    }
  }
  const res = await request<AjaxResponse<NewCategory[]>>({
    url: `${supplierSettledHost}/supplierCommonData/getCategory`,
    method: "get",
  });
  if (res.isSuccess && Array.isArray(res.result)) {
    setSessionStorageItem(cacheKey, res.result);
    return Promise.resolve({
      isSuccess: true,
      result: res.result,
    });
  }
  return res;
}
/**
 * 获取枚举
 * @param name
 * BankCardAccountNatureEnum  银行卡账户类型
 * BusinessRiskEnum 经营风险枚举类
 * CapacityFabricEnum 产能面料枚举类
 * CapacityTypeEnum 产能类型枚举类
 * CapacityNatureEnum 产能性质枚举
 * FactoryNatureEnum 工厂性质枚举类
 * FactorySizeEnum 工厂规模枚举
 * FactorySkillEnum 工厂技能枚举类
 * GradeEnum 合作程度评级（供应商等级）
 * PaymentTypeEnum  付款方式枚举类
 * PurchaseTypeEnum  采购类型枚举类
 * ScaleTypeEnum 规模类型枚举类
 * SupplierBusinessTypeEnum 供应商业务系统枚举类
 * FactoryAreaEnum 工厂区域
 * FactoryCategoryEnum 工厂类别
 * FactoryTypeEnum （产能）工厂性质
 * ProductTypeEnum （产能）产品类型
 * SupplyClassificationEnum 供货分类
 * SupplierComplianceTypeEnum 合规类型枚举类
 * SupplierInfoStatusEnum 供货商信息状态枚举类
 * SupplierIntelligenceStatusEnum 资质状态枚举类
 * SupplierStatusEnum 供应商状态枚举类
 * SupplierTypeEnum  供应商类型枚举类
 * SupplyTypeEnum 供应链类型枚举类
 * SupplyRegionEnum 供货区域
 * WorkLevelEnum 做工等级
 * CompanyTypeEnum 公司类型
 * ManagementStatusEnum 经营状态
 * SupplierClothesCapacityStatusEnum 产能状态
 * SupplierClothesCapacityFabricEnum 面料类型
 * @param useCachae 是否使用缓存
 * @returns
 */
export async function getEnum(
  name: string,
  useCachae?: boolean
): Promise<AjaxResponse<Enum[]>> {
  const localData = get(localEnums, name);
  if (Array.isArray(localData)) {
    return Promise.resolve({
      isSuccess: true,
      result: localData,
    });
  }
  if (!useCachae) {
    return request({
      url: supplierSettledHost + `/supplierSettled/queryOptions`,
      method: "get",
      params: {
        name,
      },
    });
  } else {
    const cacheKey = "supplierEnum";
    let supplierEnum: { [x: string]: Enum[] } = getSessionStorageItem(cacheKey);
    if (!supplierEnum) {
      supplierEnum = {};
    }
    const val = supplierEnum[name];
    if (Array.isArray(val) && val.length) {
      return Promise.resolve({
        isSuccess: true,
        result: val,
      });
    } else {
      const res = await request<AjaxResponse<Enum[]>>({
        url: supplierSettledHost + `/supplierSettled/queryOptions`,
        method: "get",
        params: {
          name,
        },
      });
      if (res.isSuccess && Array.isArray(res.result) && res.result.length) {
        supplierEnum[name] = res.result;
        setSessionStorageItem(cacheKey, supplierEnum);
      }
      return res;
    }
  }
}
export function getSupplierBankInfos(
  sourceType: SourceType,
  supplierId: number
): Promise<AjaxResponse<BankCardBO[]>> {
  return request({
    url:
      supplierSettledHost + `/supplierSettled/supplier/bankInfos/${supplierId}`,
    method: "get",
    params: {
      sourceType,
    },
    silence: true,
  });
}
export function getSupplierServices(
  sourceType: SourceType,
  supplierId: number
): Promise<AjaxResponse<SupplierService[]>> {
  return request({
    url:
      supplierSettledHost + `/supplierSettled/supplier/servers/${supplierId}`,
    method: "get",
    params: {
      sourceType,
    },
  });
}

export function supplierCheckByName(data: {
  sourceType: SourceType;
  supplierName: string;
  bindingPhone: string;
}): Promise<AjaxResponse<boolean>> {
  return request({
    url: supplierSettledHost + `/supplierSettled/supplierCheckByName`,
    method: "post",
    params: data,
  });
}
export function supplierCheckByBusinessNo(data: {
  sourceType: SourceType;
  businessNo: string;
  bindingPhone: string;
}): Promise<AjaxResponse<boolean>> {
  return request({
    url: supplierSettledHost + `/supplierSettled/supplierCheckByBusinessNo`,
    method: "post",
    params: data,
  });
}
/**
 * 获取尾部工厂
 * @returns
 */
export function getFactoryTail(): Promise<AjaxResponse<FactoryTailDTO[]>> {
  return request({
    url: supplierSettledHost + `/supplierCommonData/getFactoryTail`,
    method: "get",
  });
}
export function editSupplierInfo(
  data: EditSupplierInfoBody
): Promise<AjaxResponse<void>> {
  return request({
    url: supplierSettledHost + `/supplierSettled/supplier/editSupplierInfo`,
    method: "post",
    data,
  });
}
/**
 * 新增供应商信息
 * @param data
 * @returns
 */
export function createSupplierInfo(
  data: SupplierInfoSubmitBO
): Promise<AjaxResponse<void>> {
  console.log(data);
  return request({
    url: supplierSettledHost + `/supplierSettled/supplier/supplierSettled`,
    method: "post",
    data,
  });
}
/**
 * 是否已开通跨境宝
 * @param query
 * @returns
 */
export function supplierCheckKuaJiBao(query: {
  shopUrl: string;
  sourceType: number;
}): Promise<AjaxResponse<void>> {
  console.log(query);
  return request({
    url: supplierSettledHost + `/supplierSettled/supplierCheckKuaJiBao`,
    method: "post",
    params: query,
  });
}

/**
 * 发送手机验证码
 * @param data { phone:'手机号码',source:来源 14-手机绑定 15-实名认证 16-银行信息认证 17-通过手机号码修改号码 18-修改手机号码 19-通过身份证修改手机号码 20-申请电子签章 47-重新认证-通过短信验证48-重新认证-通过新手机号码验证}
 * @returns
 */
export function sendVerificationCodeByPhone(data: {
  phone: string;
  source: number;
}): Promise<AjaxResponse<boolean>> {
  return request({
    url: supplierSettledHost + `/verifyCode/sendVerificationCodeByPhone`,
    method: "post",
    data,
  });
}
/**
 * 通过手机号和验证码获取供应商信息
 * @param data { phone:'手机号码',verify_code:'验证码',source:来源 14-手机绑定 15-实名认证 16-银行信息认证 17-通过手机号码修改号码 18-修改手机号码 19-通过身份证修改手机号码 20-申请电子签章 47-重新认证-通过短信验证48-重新认证-通过新手机号码验证}
 * @returns
 */
export function getSupplierByPhone(data: {
  phone: string;
  source: number;
  verify_code: string;
}): Promise<AjaxResponse<SupplierSettledResult>> {
  return request({
    url: supplierSettledHost + `/supplierSettled/getSupplierByPhone`,
    method: "post",
    data,
  });
}

/**
 * 获取图片服务器信息
 * @returns
 */
export function getImagesServer(): Promise<HttpResponse<ImageUploadServerDTO>> {
  return request({
    url: `${supplierSettledHost}/newProduct/getImagesServer`,
    method: "get",
  });
}

/**
 * 营业执照识别
 * @returns
 */
export function distinguishOcrBusinessLicense(data: {
  image_url: string;
}): Promise<
  HttpResponse<{
    name: string;
    reg_num: string;
    person: string;
  }>
> {
  return request({
    url: `${supplierSettledHost}/supplierBusinessAuth/ocrBusinessLicense`,
    method: "post",
    data,
    silence: true,
  });
}

/**
 * 供应商入驻
 * @returns
 */
export function supplierSettled(
  data: SupplierInfoSubmitBO
): Promise<AjaxResponse<void>> {
  return request({
    url: `${supplierSettledHost}/supplierSettled/supplierSettled`,
    method: "post",
    data,
  });
}

/**
 * 邮箱验证
 * @returns
 */
export function supplierSettledEmailValited(
  code: string
): Promise<AjaxResponse<void>> {
  return request({
    url: `${supplierSettledHost}/supplierSettled/supplierSettledEmailValited`,
    method: "get",
    params: {
      code,
    },
    silence: true,
  });
}
/**
 * 获取新品类数据
 * @param id 不传id时默认获取根层级列表
 * @returns
 */
export function getNewProductCategory(
  id?: string
): Promise<HttpResponse<ResNewProductCategoryDTO[]>> {
  return request({
    url: `${supplierSettledHost}/newProduct/getNewProductCategory`,
    method: "get",
    params: {
      id,
    },
    silence: true,
  });
}
/**
 * 获取新品类详情
 * @param id
 * @returns
 */
export function getNewProductOldCategor(
  id?: string
): Promise<HttpResponse<ResNewProductCategoryDTO[]>> {
  return request({
    url: `${supplierSettledHost}/newProduct/getNewProductOldCategor`,
    method: "get",
    params: {
      id,
    },
    silence: true,
  });
}

/**
 * 通过ID获取品类详情
 * @param id
 * @returns
 */
export function getNewProductCategoryById(
  id: string
): Promise<AjaxResponse<NewProductCategoryResponseDTO>> {
  return request({
    url: `${supplierMetaHost}/suppliermeta/supplier/getNewProductCategoryById`,
    method: "post",
    params: {
      id,
    },
  });
}
